import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackContact } from '../utils/metaPixel';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#hero'
  }, {
    name: 'El Problema',
    href: '#problem'
  }, {
    name: 'Método INTEGRA®',
    href: '#method'
  }, {
    name: 'Transformación',
    href: '#transformation'
  }, {
    name: 'Testimonios',
    href: '#testimonials'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-92">
      <div className="container mx-auto px-6 max-w-6xl flex justify-between items-center" data-id="element-93">
        <a href="#hero" className="flex items-center" data-id="element-94">
          <img src="https://cdn.magicpatterns.com/uploads/uqu2kUwrDtAghAbBg9J3eh/Diseno_sin_titulo_(85).png" alt="La Conexión Cuántica Logo" className="h-14 md:h-16 object-contain" data-id="element-95" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-96">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-primary hover:text-accent font-semibold text-sm transition-colors" data-id="element-97">
              {link.name}
            </a>)}
          <a href="https://wa.link/r4i31b" target="_blank" rel="noopener noreferrer" onClick={trackContact} className="bg-primary text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-primary/90 transition-colors shadow-sm" data-id="element-98">
            Reservar Sesión
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-primary p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-99">
          {isMobileMenuOpen ? <XIcon data-id="element-100" /> : <MenuIcon data-id="element-101" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-102">
        {isMobileMenuOpen && <motion.nav initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-soft/30 overflow-hidden" data-id="element-103">
            <div className="container mx-auto px-6 py-4 flex flex-col space-y-4" data-id="element-104">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-primary font-semibold text-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-105">
                  {link.name}
                </a>)}
              <a href="https://wa.link/r4i31b" target="_blank" rel="noopener noreferrer" className="bg-primary text-white px-5 py-3 rounded-full text-center font-semibold mt-4" onClick={() => {
            trackContact();
            setIsMobileMenuOpen(false);
          }} data-id="element-106">
                Reservar Sesión
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
};